import { Form, field } from "lib/form";

export default class RfeEditForm extends Form {
  @field("Case") public caseName: string;

  @field("Base") public base: string;
}
